import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    console.log("SAGENHAFT")
    this.element.textContent = "Hello World!"
  }
}
